import { render, staticRenderFns } from "./BindPhoneDialog.vue?vue&type=template&id=1cd0ce6a&scoped=true"
import script from "./BindPhoneDialog.vue?vue&type=script&lang=js"
export * from "./BindPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./BindPhoneDialog.vue?vue&type=style&index=0&id=1cd0ce6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0ce6a",
  null
  
)

export default component.exports